import Styles from './Explanation.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useId } from '@react-aria/utils'
import { Icon } from 'components/FirstTimeExperienceModal/components/Callout/Icon'
import cx from 'classnames'

interface ExplanationProps {
  icon?: string
  children: string
  variant?: 'primary' | 'secondary'
}

export const Explanation = ({ icon, children, variant = 'primary' }: ExplanationProps) => {
  const id = useId()

  return (
    <div role="note" className={cx(Styles.root, Styles[variant])} aria-labelledby={id}>
      {icon && <Icon icon={icon} />}
      <div className={Styles.content}>
        <Text id={id}>{children}</Text>
      </div>
    </div>
  )
}
